module.exports = __webpack_public_path__ + "img/10x-dev-of-all-times.0d0ecf36.png";